import { HierarchyContextProps, IHierarchyActionRemoveSingleReplacement } from "./interface";

/**
 * Removes a single replacement from the hierarchy context state.
 *
 * @param action - The action containing the single replacement to remove
 * @param state - The current hierarchy context state
 * @returns Updated hierarchy context state without the specified single replacement
 */
export const hcr_removeSingleReplacment = (
  action: IHierarchyActionRemoveSingleReplacement,
  state: HierarchyContextProps,
): HierarchyContextProps => {
  if (!state.hierarchy)
    throw `hierarchyContextReducer: ${action.operation}: Hierarchy not assigned yet`;
  const ix = state.hierarchy.singles.findIndex((s) => s.airid === action.single!.airid);
  if (ix > -1) {
    return {
      ...state,
      hierarchy: {
        ...state.hierarchy,
        singles: state.hierarchy.singles.filter((s) => s.airid !== action.single!.airid),
      },
    };
  }
  return state;
};
